class ConsumerShippingLocationsController  {
    constructor(createAutoQuery, consumerShippingLocationPrompt) {
        let options = {
            url: 'QueryConsumerShippingLocations.json?ConsumerId=' + this.consumerId,
            pageSize: 24,
            sortBy:'Name',
            append:false,
            autoLoad:true,
            sortOptions:{
                'Id': 'Id: Low to High',
                '-Id': 'Id: High to Low',
                'Name': 'Name: A to Z',
                '-Name': 'Name: Z to A',
                'Type': 'Provider: A to Z',
                '-Type': 'Provider: Z to A',
                'Expires': 'Expires: Newest',
                '-Expires': 'Expires: Oldest',
                'Address': 'Address: A to Z',
                '-Address': 'Address: Z to A',
                'Address2': 'Address2: A to Z',
                '-Address2': 'Address2: Z to A',
                'City': 'City: A to Z',
                '-City': 'City: Z to A',
                'State': 'State: A to Z',
                '-State': 'State: Z to A',
                'Zip': 'Zip: 1 to 9',
                '-Zip': 'Zip: 9 to 1',
                'Phone': 'Phone: 1 to 9',
                '-Phone': 'Phone: 9 to 1',
                'Status': 'Status: A to Z',
                '-Status': 'Status: Z to A'
            }
        };
        this.query = createAutoQuery(options);
        this.prompt = consumerShippingLocationPrompt;
    }
    load(){return this.query.load.apply(this.query, arguments);}
    add(){return this.prompt.add(Object.assign({name: this.container.consumer.displayName, consumerId: this.consumerId}, this.container.consumer)).then(() => this.load(true));}
    edit(model){return this.prompt.edit(model).then(() => this.load(true));}
    delete(model){return this.prompt.delete(model).then(() => this.load(true));}

    $onDestroy() {
        this.query.dispose();
    }
}

class ConsumerShippingLocations{
    constructor(){
        this.require= {
            container: '^consumerContainer'
        };
        this.bindings= {
            consumerId: '@'
        };
        this.controller = ConsumerShippingLocationsController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumer-shipping-locations.html'
    }
}

export { ConsumerShippingLocationsController, ConsumerShippingLocations}

angular.module('emun.consumer').component('consumerShippingLocations', new ConsumerShippingLocations());